import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { NavLink } from "react-router-dom";
import logo from './logo.png';
import { motion } from 'framer-motion';

const Navbar = ({ onHideContent }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMobileNavClose, setIsMobileNavClose] = useState(true);
    const [width, setWidth] = useState(window.innerWidth);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(null); // Lưu trạng thái submenu

    const toggleHiddenOverflow = () => {
        const newStatus = isMobileNavClose;
        setIsMobileNavClose(!newStatus);
        onHideContent(newStatus);
    };

    const preventNavigation = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <nav className={`nav ${isMobileNavClose ? "" : "show-nav"}`}>
            <div className="header-container">
                <ul className="nav-item border-none logo-container flex-row">
                    <NavLink to="/">
                        <img src={logo} alt="logo" className="logo" />
                    </NavLink>
                    <svg
                        className={`menu-icon m-t-15 ${isMobileNavClose ? "" : "hide-icon"}`}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={toggleHiddenOverflow}
                    >
                        <path
                            d="M4 6h16M4 12h16"
                            stroke="currentColor"
                            strokeWidth="1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <svg
                        className={`menu-icon ${isMobileNavClose ? "hide-icon" : ""}`}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={toggleHiddenOverflow}
                    >
                        <path
                            d="M18 6L6 18M6 6l12 12"
                            stroke="currentColor"
                            strokeWidth="1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </ul>
                {(!isMobileNavClose || width > 640) &&
                    <motion.div
                        key="div0"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <ul className="nav-list">
                            <li className="nav-item" onClick={toggleHiddenOverflow}><NavLink to="/">Home</NavLink></li>
                            <li
                                className="nav-item dropdown"
                                onMouseEnter={() => setIsDropdownOpen(true)}
                                onMouseLeave={() => setIsDropdownOpen(false)}
                                onClick={() => { setIsDropdownOpen(!isDropdownOpen); setIsSubMenuOpen(null) }}
                            >
                                <NavLink className="nav-item-dropdown" onClick={preventNavigation} to="/Services">Services
                                    <svg
                                        className={`arrow-icon ${isDropdownOpen ? 'rotate' : ''}`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                    </svg>
                                </NavLink>
                                {(isDropdownOpen || width > 640) &&
                                    <motion.div
                                        key="div0"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 1 }}
                                    >
                                        <ul className="dropdown-content">
                                            <li
                                                className="dropdown-item"
                                                onMouseEnter={() => setIsSubMenuOpen('webdevelopment')}
                                                onMouseLeave={() => setIsSubMenuOpen(null)}
                                                onClick={() => { setIsSubMenuOpen('webdevelopment'); setIsDropdownOpen(true) }}
                                            >
                                                <NavLink to="/Services/Web-Development" onClick={preventNavigation}>Web Development
                                                    <svg
                                                        className={`sub-arrow-icon ${isSubMenuOpen === 'webdevelopment' ? 'sub-rotate' : ''}`}
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                                    </svg>
                                                </NavLink>
                                                {isSubMenuOpen === 'webdevelopment' && (
                                                    <div className="sub-dropdown">
                                                        <NavLink to="/UI-UX-Design" onClick={toggleHiddenOverflow}>UI/UX Design</NavLink>
                                                        <NavLink to="/Responsive-Websites" onClick={toggleHiddenOverflow}>Responsive Websites</NavLink>
                                                        <NavLink to="/Reactjs-Development" onClick={toggleHiddenOverflow}>React.js Development</NavLink>
                                                        <NavLink to="/SEO-Optimization" onClick={toggleHiddenOverflow}>SEO Optimization</NavLink>
                                                        <NavLink to="/CMS-Solutions" onClick={toggleHiddenOverflow}>CMS Solutions</NavLink>
                                                        <NavLink to="/Web-Security" onClick={toggleHiddenOverflow}>Web Security</NavLink>
                                                    </div>
                                                )}
                                            </li>
                                            <li
                                                className={`dropdown-item ${isSubMenuOpen === 'webdevelopment' ? "m-t-200" : ""}`}
                                                onMouseEnter={() => setIsSubMenuOpen('aiservices')}
                                                onMouseLeave={() => setIsSubMenuOpen(null)}
                                                onClick={() => { setIsSubMenuOpen('aiservices'); setIsDropdownOpen(true) }}
                                            >
                                                <NavLink to="/Services/AI" onClick={preventNavigation}>Artificial Intelligence (AI)
                                                    <svg
                                                        className={`sub-arrow-icon ${isSubMenuOpen === 'aiservices' ? 'sub-rotate' : ''}`}
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                                    </svg>
                                                </NavLink>
                                                {isSubMenuOpen === 'aiservices' && (
                                                    <div className={`sub-dropdown ${isSubMenuOpen === 'aiservices' ? "m-t-35" : ""}`}>
                                                        <NavLink to="/NLP-Solutions" onClick={toggleHiddenOverflow}>NLP Solutions</NavLink>
                                                        <NavLink to="/Computer-Vision" onClick={toggleHiddenOverflow}>Computer Vision</NavLink>
                                                        <NavLink to="/Machine-Learning" onClick={toggleHiddenOverflow}>Machine Learning</NavLink>
                                                        <NavLink to="/Data-Analytics" onClick={toggleHiddenOverflow}>Data Analytics</NavLink>
                                                        <NavLink to="/AI-Automation" onClick={toggleHiddenOverflow}>AI Automation</NavLink>
                                                        <NavLink to="/AI-for-BI" onClick={toggleHiddenOverflow}>AI for BI</NavLink>
                                                    </div>
                                                )}
                                            </li>
                                            <li
                                                className={`dropdown-item ${isSubMenuOpen === 'aiservices' ? "m-t-200" : ""}`}
                                                onMouseEnter={() => setIsSubMenuOpen('dynamicsd365')}
                                                onMouseLeave={() => setIsSubMenuOpen(null)}
                                                onClick={() => { setIsSubMenuOpen('dynamicsd365'); setIsDropdownOpen(true) }}
                                            >
                                                <NavLink to="/Services/Dynamics-D365" onClick={preventNavigation}>Dynamics 365
                                                    <svg
                                                        className={`sub-arrow-icon ${isSubMenuOpen === 'dynamicsd365' ? 'sub-rotate' : ''}`}
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                                    </svg>
                                                </NavLink>
                                                {isSubMenuOpen === 'dynamicsd365' && (
                                                    <div className={`sub-dropdown ${isSubMenuOpen === 'dynamicsd365' ? "m-t-75" : ""}`}>
                                                        <NavLink to="/CRM-Solutions" onClick={toggleHiddenOverflow}>CRM Solutions</NavLink>
                                                        <NavLink to="/Finance-Automation" onClick={toggleHiddenOverflow}>Finance Automation</NavLink>
                                                        <NavLink to="/Business-Central" onClick={toggleHiddenOverflow}>Business Central</NavLink>
                                                        <NavLink to="/Field-Service" onClick={toggleHiddenOverflow}>Field Service</NavLink>
                                                        <NavLink to="/AI-Insights" onClick={toggleHiddenOverflow}>AI Insights</NavLink>
                                                        <NavLink to="/Customization" onClick={toggleHiddenOverflow}>Customization</NavLink>
                                                    </div>
                                                )}
                                            </li>
                                        </ul>
                                    </motion.div>}
                            </li>
                            <li className={`nav-item ${isDropdownOpen ? isSubMenuOpen ? "m-t-310" : "m-t-100" : ""}`} onClick={toggleHiddenOverflow}><NavLink to="/Blogs">Blogs</NavLink></li>
                            {/* <li className="nav-item" onClick={toggleHiddenOverflow}><NavLink to="/Org-Chart">ORG Chart</NavLink></li> */}
                            <li className="nav-item" onClick={toggleHiddenOverflow}><NavLink to="/About-Us">About Us</NavLink></li>
                            <li className="nav-item nav-left-item border-none button-mobile" onClick={toggleHiddenOverflow}><NavLink to="/contact"><button>Contact Us</button></NavLink></li>
                        </ul>
                    </motion.div>}
            </div>
        </nav>
    );
}

export default Navbar;
